import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Loader, Dropdown, Label, Icon, Menu
} from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import { BY_COLOR, renderColorSelection } from 'arts/components/works/color_filters';
import Work from './work';
import * as classes from './classes.module.scss';
import Const from '../../config/const';
import Search from './search';

const renderCurrentFilter = (key, activeFilters, removeFilter) => {
  let content = null;
  if (key === BY_COLOR) {
    const hexColor = parseInt(activeFilters[key].value, 10).toString(16).padStart(6, '0');
    content = (
      <div className={ classes.byColor }>
        Color:&nbsp;
        <div style={ { backgroundColor: `#${ hexColor }` } } />
      </div>
    );
  } else {
    content = activeFilters[key].text;
  }
  return (
    <Label key={ key } onClick={ () => removeFilter(key) }>
      { content }
      <Icon name="delete" />
    </Label>
  );
};

export default class FindWorks extends PureComponent {
  static propTypes = {
    loadNextPage: PropTypes.func.isRequired,
    addToCanvas: PropTypes.func.isRequired,

    loadArtFilters: PropTypes.func,
    addFilter: PropTypes.func,
    removeFilter: PropTypes.func,

    closePanel: PropTypes.func.isRequired,
    showMoreLikeThis: PropTypes.func.isRequired,
    works: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.array,
    activeFilters: PropTypes.object,

    pinned: PropTypes.bool.isRequired,
    onlyFavorites: PropTypes.bool
  };

  scroll = React.createRef();

  componentDidMount() {
    const { loadNextPage, loadArtFilters } = this.props;
    if (loadArtFilters) {
      loadArtFilters();
    }
    loadNextPage();
  }

  closePanel = () => {
    const { closePanel } = this.props;
    closePanel(Const.panelKinds.works);
  }

  addToCanvas = (opts) => {
    const { addToCanvas, pinned } = this.props;
    addToCanvas(opts);
    if (!pinned) {
      this.closePanel();
    }
  };

  addSeachFilter = (query) => {
    const { addFilter, removeFilter } = this.props;
    if (query) {
      addFilter('query', query, query);
    } else {
      removeFilter('query');
    }
  }

  renderLoader() {
    const { loading } = this.props;
    if (!loading) { return null; }
    return (
      <div className={ classes.loader }>
        <Loader active inline />
      </div>
    );
  }

  renderMenuFilter({ key, options, title }) {
    const { addFilter } = this.props;
    const onSelect = (id) => addFilter(key, id, id);
    return (
      <Dropdown item text={ title.toUpperCase() } key={ title } className={ classes[key] }>
        <Dropdown.Menu>
          {
            key === BY_COLOR ? (
              <div className={ classes.awColor }>
                { renderColorSelection(onSelect, options, classes.colorLine, classes.singleColor) }
              </div>
            ) : (
              options.map(({ id, name }) => (
                <Dropdown.Item key={ id } onClick={ () => addFilter(key, id, name) }>
                  { name }
                </Dropdown.Item>
              ))
            )
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderFilters() {
    const { filters, addFilter } = this.props;
    if (!filters.length) {
      return this.renderLoader();
    }
    const topFilters = filters.filter((f) => !f.group);
    const groupFilters = filters.filter((f) => f.group);
    return (
      <div className={ classes.headerFilters }>
        <div className={ classes.filters }>
          <Menu secondary>
            {
              topFilters.map((f) => this.renderMenuFilter(f))
            }
            <Dropdown item text="MORE FILTERS">
              <Dropdown.Menu className={ classes.moreFilter }>
                { groupFilters.map((f) => this.renderMenuFilter(f)) }
                <Dropdown.Item onClick={ () => addFilter('newest_only', 'true', 'New Arrivals') }>
                  NEW ARRIVALS
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu>
        </div>
        <Search onChange={ this.addSeachFilter } />
      </div>
    );
  }

  renderWorks() {
    const { works, showMoreLikeThis } = this.props;
    return works.map((w, index) => (
      <Work
        addToCanvas={ this.addToCanvas }
        showMoreLikeThis={ showMoreLikeThis }
        key={ w.id }
        index={ index }
        moreSource={ Const.moreLikeThisSources.works }
        { ...w }
      />
    ));
  }

  renderActiveFilters() {
    const { activeFilters, removeFilter } = this.props;
    if (!Object.keys(activeFilters).length) { return null; }

    return (
      <div className={ classes.activeFilters }>
        {
          Object.keys(activeFilters).map(
            key => renderCurrentFilter(key, activeFilters, removeFilter)
          )
        }
      </div>
    );
  }

  render() {
    const { onlyFavorites, loadNextPage } = this.props;

    if (onlyFavorites) {
      return (
        <>
          <div className={ classes.works }>
            { this.renderWorks() }
            { this.renderLoader() }
          </div>
          <Waypoint onEnter={ loadNextPage }>
            <span>
              &nbsp;
            </span>
          </Waypoint>
        </>
      );
    }

    return (
      <>
        { this.renderFilters() }
        <div>
          { this.renderActiveFilters() }
        </div>
        <div className={ classes.wHolder } ref={ this.scroll }>
          <div className={ classes.works }>
            { this.renderWorks() }
            { this.renderLoader() }
          </div>
          <Waypoint onEnter={ loadNextPage } scrollableAncestor={ this.scroll.current }>
            <span>
              &nbsp;
            </span>
          </Waypoint>
        </div>
      </>
    );
  }
}
